<template>
  <div class="form-group" :class="[ to.inputType, {'formly-has-value': model[field.key], 'formly-has-focus': form[field.key].$active, 'has-error': hasError}]">
    <label v-if="to.label" v-text="$t('formly.fields.' + to.label)"></label>
    <div class="editor-wrapper">
      <vue-tel-input mode="international" v-model="parsedValue"></vue-tel-input>
      <span class="help-block form-text text-danger"
            v-if="form.$errors[field.key]?.length > 0"
            v-text="$t('validation.' + field.key + '.' + form.$errors[field.key][0])" />
    </div>
     <error-display v-if="form.$errors[field.key]?.length > 0" :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import baseField from 'vue-formly-bootstrap/src/fields/baseField'

import { VueTelInput } from 'vue-tel-input'

// background: linear-gradient(15.92deg, #FFA767 16.87%, #EE6B33 94.68%);
export default {
  components: { VueTelInput },
  mixins: [baseField],
  computed: {
    parsedValue: {
      get () {
        return this.model[this.field.key] ?? ''
      },
      set (value) {
        this.model[this.field.key] = value
      }
    }
  }
}
</script>
